import React from 'react';
import ConceptScheme from './ConceptScheme';

/** Отображение  таксономии на основе SKOS. Для отбражения используется список ConceptScheme, которые содержат набор концептов.
 * Для отображения передаётся URI схемы
 * Пример элемента списка:
 * { "IRI": { "type": "uri", "value": "http://csi.semanticpro.org/authority/domain" }	, "Label": { "type": "literal", "xml:lang": "ru", "value": "domain" }},
*/
class Taxonomy extends React.Component {	

  render() {
    const {taxonomy, onChange} = this.props;
    //const taxonomy = null;
    //Формируем массив доступных схем, описание схемы берём из taxonomy
    //console.log(this);
    return (
      <span>
        {!taxonomy && "Таксономия каталога не задана или не загружена!"}
        {taxonomy && taxonomy.map((schema, i) =>  
            <ConceptScheme key={i} schema={schema} onChange={onChange} />
        )}
      </span>
    )
  }
}

export default Taxonomy;